<template>
  <div>
    <div class="advanceParent">
      <export-excel
        :data="payments"
        :fields="excelHeaders"
        worksheet="My Worksheet"
        name="گزارش پرداخت ها.xls"
      >
        <app-history class="advancedSearch" title="خروجی اکسل" />
      </export-excel>
    </div>
    <div>
      <v-data-table
        :items="payments"
        :server-items-length="totalCount"
        :headers="paymentsHeaders"
        class="elevation-1 rounded"
        :footer-props="{
          itemsPerPageAllText: 'همه',
          itemsPerPageText: 'تعداد ردیف',
          itemsPerPageOptions: [10],
        }"
        :no-data-text="tableText"
        :header-props="$store.getters.headerProps"
        @pagination="doPage"
      >
        <template v-slot:[`item.amount`]="{ item }">
          {{ Number(item.amount).toLocaleString() }}
        </template>
        <template v-slot:[`item.detail`]="{ item }">
          <font-awesome-icon
            icon="angle-left"
            class="navIcon"
            title="مشاهده جزییات"
            @click="handleShowDetail(item)"
          />
        </template>

        <template v-slot:[`footer.page-text`]="{ pageStart, pageStop }">
          از {{ pageStart }} تا {{ pageStop }}
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import HistoryButton from "@/components/HistoryButton";
import Dialog from "@/components/Dialog";
import { GetSchoolPardakhtDetail } from "@/api/payments";
import moment from "moment-jalaali";
export default {
  components: {
    appHistory: HistoryButton,
    appDialog: Dialog,
  },
  data() {
    return {
      showPaymentDialog: false,
      payments: [],

      paymentsHeaders: [
        {
          text: "تاریخ شروع",
          value: "startDate",
          width: "15%",
          cellClass: "cellLtr",
        },
        {
          text: "تاریخ پایان",
          value: "endDate",
          width: "15%",
          cellClass: "cellLtr",
        },
        {
          text: "بانک",
          value: "bankName",
        },
        {
          text: "شماره حساب",
          value: "acountNumber",
        },
        {
          text: "شبا",
          value: "sheba",
        },

        {
          text: "مبلغ",
          value: "amount",
        },
        {
          text: "تاریخ پرداخت",
          value: "state",

          sortable: false,
        },
      ],
      excelHeaders: {
        "تاریخ شروع": "startDate",
        "تاریخ پایان": "endDate",
        بانک: "bankName",
        "شماره حساب": "acountNumber",
        شبا: "sheba",

        "جمع پرداخت های اینترنتی (ریال)": {
          field: "amount",
          callback: (value) => {
            return Number(value).toLocaleString();
          },
        },
        "تاریخ پرداخت": "state",
      },

      showDetail: false,
      totalCount: 0,
      selectedItem: {},
    };
  },
  created() {
    this.GetSchoolPardakhtDetail(0);
  },
  computed: {
    tableText() {
      return this.$store.getters.tableText;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
    currentBranch() {
      return this.$store.getters.currentBranch;
    },
  },

  methods: {
    GetSchoolPardakhtDetail(skip) {
      if (isNaN(skip)) skip = 0;
      this.$store.commit("SET_TABLE_TEXT", true);
      return new Promise((resolve, reject) => {
        GetSchoolPardakhtDetail(this.currentBranch.id, skip)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.payments = response.data.items;
            this.totalCount = response.data.count;
            this.$store.commit("SET_TABLE_TEXT", false);

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async GetDataForExcel() {
      const response = await GetSchoolPardakhtDetail(-1);
      return response.data.items;
    },
    convertDate(date) {
      return moment(date).format("jYYYY/jMM/jDD HH:mm:ss");
    },
    doPage($event) {
      this.GetSchoolPardakhtDetail(($event.page - 1) * 10);
    },
  },
};
</script>
<style>
.text-start.cellLtr {
  direction: ltr;
  text-align: end !important;
}
</style>
